<template>
  <div class="item-list">
    <a-tag class="item-list-li" closable @close="handleClose(i)" v-for="(li, i) in list" :key="`${li}_${i}`">{{ li }}</a-tag>
    <template v-if="edit">
      <slot name="input" v-bind:action="confirmCallback" v-if="$scopedSlots.input"></slot>
      <a-input ref="input" style="width: 120px" auto-focus v-model="str" @blur="handleInputConfirm" @keyup.enter="handleInputConfirm" v-else></a-input>
    </template>
    <a-tag style="background: #fff; borderStyle: dashed;cursor:pointer;" @click="addItem" v-else><a-icon type="plus"/> {{addTitle}}</a-tag>
  </div>
</template>

<script>

    export default {
        name: "item-list",
        model: {
            event: "change"
        },
        props: {
            value: [String, Array],
            addTitle: {
                type: String,
                default: '添加条目'
            }
        },
        data() {
            return {
                list: [],
                str: null,
                edit: false
            }
        },
        watch: {
            value() {
                this.setList();
            }
        },
        created() {
            this.setList();
        },
        methods: {
            setList() {
                let value = this.value;
                let list = [];
                if(value) {
                    if(typeof value === "string") {
                        try {
                            list = value.split(",");
                        } catch (e) {
                            console.error(e);
                        }
                    } else {
                        list = [...value];
                    }
                }
                this.list = list;
            },
            addItem() {
                this.str = null;
                this.edit = true;
                this.$nextTick(() =>{
                    this.$refs.input?.focus();
                });
            },
            handleClose(i) {
                this.list.splice(i, 1);
                this.dispatchChange();
            },
            confirmCallback(val) {
                if (val && !this.list.includes(val)) {
                    this.list.push(val);
                    this.dispatchChange();
                }
                this.edit = false;
            },
            handleInputConfirm() {
                let str = this.str;
                if(str && this.list.indexOf(str) === -1) {
                    this.list.push(str);
                    this.dispatchChange();
                }
                this.edit = false;
            },
            dispatchChange() {
                let list = this.list;
                this.$emit("change", list && list.length > 0 ? list.join(",") : null);
            }
        }
    }
</script>

<style scoped>

</style>
